import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem } from 'reactstrap';
import NotFoundPage from "../containers/NotFoundPage";

class SinglePage extends Component {
    render() {
        if (this.props.getSinglePage.loading) {
            return 'getSinglePage Loading...'
        };
        if (this.props.getSinglePage.error) {
            return 'getSinglePage Error fetch data';
        }
        let singlePage = this.props.getSinglePage.getSinglePageBySlug;
        if (singlePage == null) {
            return <NotFoundPage />;
        }

        const divStyle =
        {
            margin: '10px',
        }

        return (
                <div className="top">
                    <div className="container">
                        <div>
                            <Breadcrumb>
                                <BreadcrumbItem><a href="/">Trang chủ</a></BreadcrumbItem>
                                <BreadcrumbItem active>{singlePage.title}</BreadcrumbItem>
                            </Breadcrumb>
                        </div>
                        <div className="text-center lead text-success">
                            {singlePage.title}
                        </div>
                        <div className="mt-1 mr-1 ml-1 mb-1" style={divStyle}>
                            <div dangerouslySetInnerHTML={{ __html: singlePage.content }} />
                        </div>
                    </div>
                </div>
        )
    }
}

export default SinglePage;



// WEBPACK FOOTER //
// ./src/components/SinglePage.js